import ProgressiveImageBase from 'react-progressive-image';
import React from 'react';

// Type wrapper for react-progressive-image (unmaintained package with outdated types for React 18)
const ProgressiveImage = ProgressiveImageBase as React.ComponentType<{
  src: string;
  placeholder: string;
  children: (src: string, loading: boolean) => React.ReactNode;
  onError?: (errorEvent?: Error | Event) => void;
}>;

export default ProgressiveImage;
